import BecomeMemberBanner from './BecomeMemberBanner';

export default BecomeMemberBanner;
